import { LoadingBar } from "@tutellus/tutellus-components"
import { useTranslation } from "react-i18next"
import { GT3_LOGO } from "../../js/const/logos"

export const Loading = () => {
  const { t } = useTranslation()

  return <LoadingBar mode="dark" isFullScreen icon={<img src={GT3_LOGO} alt={t("tutellus")}></img>} />
}
